/* ==========================================================================
   CUTMORE — kleine Helfer fuer die CI-Sections
   Eingebunden ueber snippets/lumin-styles-scripts.liquid.

   Zweck: Sprungziele, die nicht als feste id im Markup stehen koennen,
   weil sie aus dynamisch benannten Sections oder App-Bloecken kommen.
   Beispiel: Der Hero-CTA "Passenden Schaerfer finden" soll zur
   Produktwahl scrollen. Deren DOM-id lautet ci-ch-template--<id>__chooser
   und ist damit nicht vorhersagbar. Statt eine Zwischenseite zu verlinken,
   wird der Alias #produkte hier zur Laufzeit aufgeloest.

   Faellt das Ziel weg (z. B. Section entfernt), greift ein sinnvoller
   Fallback statt eines toten Links.
   ========================================================================== */
(function () {
  'use strict';

  var ALIASES = {
    '#produkte': {
      selector: '[id^="ci-ch-"]',
      fallback: '/collections/all'
    },
    '#bewertungen': {
      selector: '#judgeme_product_reviews, .jdgm-rev-widg, #looxReviews, .loox-reviews-default',
      fallback: null
    }
  };

  function resolve(hash) {
    var alias = ALIASES[hash];
    if (alias) {
      var el = document.querySelector(alias.selector);
      if (el) return { el: el };
      if (alias.fallback) return { href: alias.fallback };
      return null;
    }
    try {
      var direct = document.querySelector(hash);
      if (direct) return { el: direct };
    } catch (e) { /* ungueltiger Selektor — ignorieren */ }
    return null;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;

    var href = a.getAttribute('href');
    if (!href || href.indexOf('#') === -1) return;

    // Nur eigene Seite: entweder reiner Hash oder gleicher Pfad
    var hash = href.charAt(0) === '#' ? href : null;
    if (!hash && a.pathname === window.location.pathname) {
      hash = href.slice(href.indexOf('#'));
    }
    if (!hash || hash === '#') return;
    if (!ALIASES[hash] && !document.querySelector(hash)) return;

    var target = resolve(hash);
    if (!target) return;

    e.preventDefault();

    if (target.href) {
      window.location.href = target.href;
      return;
    }

    target.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', hash);
    }
  }, false);
})();
